import { MulticastDelegate } from "./MulticastDelegate";
import { ObservableCollectionEntry } from "./ObservableCollectionEntry";
import { ObservableCollectionEntryEventArgs } from "./ObservableCollectionEntryEventArgs";
import { PropertyObservable } from "./PropertyObservable";
import { PropertyObservedEventArgs } from "./PropertyObservedEventArgs";
export class ObservableCollection extends PropertyObservable {
  get count() {
    return this._entries.length;
  }

  get entries() {
    return this._entries;
  }

  get items() {
    return this._entries.reduce((items, entry) => {
      items.push(entry.item);
      return items;
    }, new Array());
  }

  constructor(eventDelegate = MulticastDelegate, name) {
    super(eventDelegate, name);
    this._entries = new Array();
    this.entryAdded = void 0;
    this.entryChanged = void 0;
    this.entryRemoved = void 0;
    this.entryAdded = new eventDelegate(this);
    this.entryChanged = new eventDelegate(this);
    this.entryRemoved = new eventDelegate(this);
  }

  onEntryAdded(sender, ea) {
    ea.entry.propertyChanged.subscribe(this.onEntryPropertyChanged, this);
    this.entryAdded.invoke(ea);
  }

  onEntryChanged(sender, ea) {
    this.entryChanged.invoke(ea);
  }

  onEntryPropertyChanged(sender, ea) {
    this.onEntryChanged(this, new ObservableCollectionEntryEventArgs(sender, ea));
    this.onReferenceObserved('entries', this._entries);
  }

  onEntryItemPropertyChanged(sender, ea) {
    const entry = this._entries.find(_entry => _entry.item == sender);

    this.onEntryPropertyChanged(entry, new PropertyObservedEventArgs('Item', entry.Item, entry.Item, ea));
  }

  onEntryRemoved(sender, ea) {
    ea.entry.propertyChanged.unsubscribe(this.onEntryPropertyChanged);
    ea.entry.item.propertyChanged.unsubscribe(this.onEntryItemPropertyChanged);
    this.entryRemoved.invoke(ea);
  }

  addEntry(...entries) {
    entries.forEach(entry => entry.item.propertyChanged.subscribe(this.onEntryItemPropertyChanged, this));

    this._entries.push(...entries);

    this.onEntriesChanged && this.onEntriesChanged();
    entries.forEach(entry => {
      this.onEntryAdded(this, new ObservableCollectionEntryEventArgs(entry));
    });
    this.onReferenceObserved('entries', this._entries);
  }

  createEntry(item) {
    const entry = new ObservableCollectionEntry(this, item, this._eventDelegate);
    return entry;
  }

  add(item) {
    const entry = this.createEntry(item);
    this.addEntry(entry);
    return entry;
  }

  addRange(...items) {
    const entries = new Array();
    items.forEach(item => {
      const entry = this.createEntry(item);
      if (entry) entries.push(entry);
    });
    this.addEntry(...entries);
    return entries;
  }

  remove(entry) {
    this._entries.splice(this._entries.indexOf(entry), 1);

    this.onEntriesChanged && this.onEntriesChanged();
    this.onEntryRemoved(this, new ObservableCollectionEntryEventArgs(entry));
    this.onReferenceObserved('entries', this._entries);
  }

}
